import { AutoOrderConfigurationDto } from "../../../screens/portfolio-info/types/AutoOrderConfigurationDto";
import { createAuthenticatedApiClient, headerValues } from "./AuthenticatedApiClient";

type ApiClient = ReturnType<typeof createAuthenticatedApiClient>;

export function createOrderApi(apiClient: ApiClient) {
    const saveAutoOrderConfiguration = async (
        orderId: number,
        autoOrderConfiguration: AutoOrderConfigurationDto,
    ): Promise<AutoOrderConfigurationDto | null> => {
        try {
            const response = await apiClient.put<AutoOrderConfigurationDto, AutoOrderConfigurationDto>(
                `api/orders/${orderId}/auto-order-configuration`,
                autoOrderConfiguration,
                { headers: headerValues.appJson },
            );

            return response?.data ?? null;
        } catch (error: any) {
            console.log(error);
            return null;
        }
    };

    const fetchAutoOrderConfiguration = async (
        orderId: number,
    ): Promise<AutoOrderConfigurationDto | null> => {
        try {
            const response = await apiClient.get<AutoOrderConfigurationDto | null>(
                `api/orders/${orderId}/auto-order-configuration`,
            );

            return response?.data ?? null;
        } catch (error: any) {
            console.log(error);
            return null;
        }
    };

    const resetAutoOrderConfigurationState = async (
        orderId: number,
    ): Promise<AutoOrderConfigurationDto | null> => {
        try {
            const response = await apiClient.put<AutoOrderConfigurationDto>(
                `api/orders/${orderId}/auto-order-configuration/state/reset`,
                null,
                { headers: headerValues.appJson },
            );

            return response?.data ?? null;
        } catch (error: any) {
            console.log(error);
            return null;
        }
    };

    return {
        saveAutoOrderConfiguration,
        fetchAutoOrderConfiguration,
        resetAutoOrderConfigurationState,
    };
}
